module.exports = __webpack_public_path__ + "static/img/ability03.c3ae1b7b.webp";